module.exports = __webpack_public_path__ + "img/goodsB1.3bc2f323.png";